import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { catchError, mergeMap, of } from 'rxjs'
import { show_error_action } from '../action/common/common.action'
import { save_feedback_action, save_feedback_success_action } from '../action/feedback.action'
import { HelpFeedbackService } from 'src/app/services/help/help-feedback.service'

@Injectable()
export class FeedbackEffects {
  constructor(private actions$: Actions, private feedbackService: HelpFeedbackService) {}

  save_feedback_action$ = createEffect(() =>
    this.actions$.pipe(
      ofType(save_feedback_action),
      mergeMap(({ feedback }) =>
        this.feedbackService.callSaveApi(feedback).pipe(
          mergeMap(response => [
            save_feedback_success_action({
              feedback: response
            })
          ]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )
}
